import { defaultHttpClient } from '../../httpClient';
import type { GetIconsSummaryResponse } from './types';

/**
 * - 카테고리 탭 상단 아이콘(요약) 조회 API
 */
export const getIconsSummary = () => {
  return defaultHttpClient
    .request<GetIconsSummaryResponse>({
      method: 'GET',
      url: '/api/v2/overview/icons/summary',
    })
    .then(result => result.data);
};
